import { marked } from 'marked'
import sanitize from 'widget-components/utilities/sanitize'

const renderer = new marked.Renderer()
renderer.link = (href, title, text) => `<a target="_blank" href="${href}" title="${title ?? ''}">${text}</a>`
renderer.heading = (text, level) => `<div class="md-h${level}">${text}</div>`

const options: marked.MarkedOptions = { renderer, gfm: true, breaks: true }

export default (text = '') => {
    const sanitized = sanitize(text)
    const html = (marked.parse(sanitized, options) as string).trim()
    if (!html || html === `<p>${sanitized}</p>`) {
        return sanitized
    }

    // Single paragraph — preserve current <p data-markdown> wrapper
    const closingP = html.indexOf('</p>')
    if (html.startsWith('<p>') && closingP === html.length - 4) {
        return `<p data-markdown="true">${html.slice(3, -4)}</p>`
    }

    // Block-level content (headings, multiple paragraphs, etc.)
    return `<div data-markdown="true">${html}</div>`
}
